import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function SupportResources() {
  const scrollToPartner = () => {
    const element = document.getElementById('partner');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-white" data-id="element-113">
      <Container data-id="element-114">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-115">
          <div className="order-2 md:order-1" data-id="element-116">
            <h2 className="text-4xl font-serif text-[#2D2D2D] mb-6" data-id="element-117">
              Support & Resources
            </h2>
            <p className="text-lg text-[#555555] mb-6 leading-relaxed" data-id="element-118">
              We support a range of schools and organizations looking to
              implement fatherhood initiatives. Our goal is to make it easy for
              institutions to support families.
            </p>
            <p className="text-lg text-[#555555] mb-8 leading-relaxed" data-id="element-119">
              Whether you are a school principal, a community leader, or a
              concerned parent, there are ways to get involved and bring the
              Good Father Project to your community.
            </p>
            <Button onClick={scrollToPartner} variant="outline" data-id="element-120">
              Inquire About Resources
            </Button>
          </div>
          <div className="order-1 md:order-2 relative" data-id="element-121">
            <div className="relative inline-block" data-id="element-122">
              {/* Decorative elements */}
              <svg className="absolute -top-6 -right-6 w-14 h-14 text-[#3D5A4C] opacity-60" viewBox="0 0 100 100" fill="none" data-id="element-123">
                <path d="M30 50 L45 50 M50 30 L50 45 M55 50 L70 50 M50 55 L50 70" stroke="currentColor" strokeWidth="4" strokeLinecap="round" data-id="element-124" />
              </svg>
              <svg className="absolute -bottom-4 -left-4 w-12 h-12 text-[#3D5A4C] opacity-50" viewBox="0 0 100 100" fill="none" data-id="element-125">
                <path d="M20 50 Q35 20 50 50 T80 50" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-126" />
              </svg>
              <svg className="absolute top-1/4 -left-8 w-8 h-8 text-[#3D5A4C] opacity-40" viewBox="0 0 100 100" fill="none" data-id="element-127">
                <path d="M50 20 L60 40 L80 50 L60 60 L50 80 L40 60 L20 50 L40 40 Z" fill="currentColor" data-id="element-128" />
              </svg>

              {/* Circular image with border */}
              <div className="relative w-full max-w-md" data-id="element-129">
                <div className="aspect-square rounded-full overflow-hidden border-4 border-[#3D5A4C] shadow-lg" data-id="element-130">
                  <img src="https://cdn.magicpatterns.com/uploads/mRSUFb1R5TALR4euNcSuGT/494055202-9374529915992674-2541877543127810459-n_orig.jpg" alt="Father and child together" className="w-full h-full object-cover" data-id="element-131" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}